/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleAccountProfile } from './GoogleAccountProfile';
import {
    GoogleAccountProfileFromJSON,
    GoogleAccountProfileFromJSONTyped,
    GoogleAccountProfileToJSON,
    GoogleAccountProfileToJSONTyped,
} from './GoogleAccountProfile';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { Workspace } from './Workspace';
import {
    WorkspaceFromJSON,
    WorkspaceFromJSONTyped,
    WorkspaceToJSON,
    WorkspaceToJSONTyped,
} from './Workspace';

/**
 * 
 * @export
 * @interface GoogleAccount
 */
export interface GoogleAccount {
    /**
     * Unique identifier for this Google account connection
     * @type {string}
     * @memberof GoogleAccount
     */
    id: string;
    /**
     * 
     * @type {User}
     * @memberof GoogleAccount
     */
    user: User;
    /**
     * 
     * @type {Workspace}
     * @memberof GoogleAccount
     */
    workspace: Workspace;
    /**
     * Google email address
     * @type {string}
     * @memberof GoogleAccount
     */
    email: string;
    /**
     * Timestamp when the OAuth token expires
     * @type {Date}
     * @memberof GoogleAccount
     */
    tokenExpiresAt: Date;
    /**
     * Whether this Google account connection is active
     * @type {boolean}
     * @memberof GoogleAccount
     */
    enabled: boolean;
    /**
     * 
     * @type {GoogleAccountProfile}
     * @memberof GoogleAccount
     */
    profile?: GoogleAccountProfile;
}

/**
 * Check if a given object implements the GoogleAccount interface.
 */
export function instanceOfGoogleAccount(value: object): value is GoogleAccount {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('workspace' in value) || value['workspace'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('tokenExpiresAt' in value) || value['tokenExpiresAt'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function GoogleAccountFromJSON(json: any): GoogleAccount {
    return GoogleAccountFromJSONTyped(json, false);
}

export function GoogleAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user': UserFromJSON(json['user']),
        'workspace': WorkspaceFromJSON(json['workspace']),
        'email': json['email'],
        'tokenExpiresAt': (new Date(json['tokenExpiresAt'])),
        'enabled': json['enabled'],
        'profile': json['profile'] == null ? undefined : GoogleAccountProfileFromJSON(json['profile']),
    };
}

export function GoogleAccountToJSON(json: any): GoogleAccount {
    return GoogleAccountToJSONTyped(json, false);
}

export function GoogleAccountToJSONTyped(value?: GoogleAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user': UserToJSON(value['user']),
        'workspace': WorkspaceToJSON(value['workspace']),
        'email': value['email'],
        'tokenExpiresAt': value['tokenExpiresAt'].toISOString(),
        'enabled': value['enabled'],
        'profile': GoogleAccountProfileToJSON(value['profile']),
    };
}

